import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import Paint from '@blade/common/components/paint/src/index.vue';
import DirectionManager from '@blade/common/components/paint/src/direction-manager';
import { Watch, Prop } from 'vue-property-decorator';
// import VideoPlayer from '@blade-sxp/monitor/components/player/simple-player.vue';
import { getEndPoint } from '@blade-sxp/monitor/utils/rzcanvas/util';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import { Scale } from '@blade/common/utils/auto-scale';
// eslint-disable-next-line no-use-before-define
let VideoDrawer = class VideoDrawer extends Vue {
    // graph正方向处理
    directionManager;
    type = 'unknown';
    directionConfig;
    typeWithDirection = {};
    minGraphSize = { width: 150, height: 150 };
    selectGraph; // vue不能监听新增属性
    selectGraphId = '';
    drawStatus = false;
    style = { width: 738, height: 415 };
    styleProp;
    // options?: DrawerOptions;
    showSelect;
    showPoints;
    indexActive;
    polygonPoints; // 地图已绘制的点数
    // 已经执行过保存或初始图集
    atlas = [];
    // 含有方向信息的图集
    atlasWidthDirection = [];
    dataSource;
    limits;
    buttons;
    isShow;
    verticePosition;
    get pointWH() {
        const { width, height } = this.styleProp;
        return { width: `${Number(width) * Scale}px`, height: `${Number(height) * Scale}px` };
    }
    onChangeDataSource(val) {
        this.setDefaultType(this.buttons);
        this.atlas = this.relative(val);
        this.regainDirections(this.atlas);
    }
    onchangePaintState(val) {
        this.drawStatus = val;
    }
    onchangeRoiType(val) {
        this.selectGraphId = '';
    }
    async onSpecifiedStyleChange(specifiedStyle) {
        if (Number(specifiedStyle?.width) > 0) {
            this.style = specifiedStyle;
            const paint = this.$refs.paint;
            paint.resize && (await paint.resize());
            this.atlas = this.relative(this.dataSource);
            this.regainDirections(this.atlas);
        }
    }
    onButtonsChange(value) {
        this.setDefaultType(value);
    }
    onFinish(atlas, graph) {
        if (!this.check(atlas)) {
            this.$message.warning(this.$t('exceedLimit').toString());
            return void this.deleteGraph(graph.id);
        }
        MapPolygonsModule.updateCurrPolygonPoints(0); // 重置绘制point number
        this.setDirection(graph, atlas);
        console.log('onFinish:', atlas, this.atlas, graph);
        this.handleSave();
    }
    onUpdate(atlas) {
        // this.$emit('drawend', this.abs(this.atlas));
        this.regainDirections(atlas);
        this.clearSelect();
    }
    onMessage(message) {
        const msg = message.code === '100' ? this.$t('concaveError').toString() : message.msg;
        this.$message({ type: message.type, message: msg });
    }
    onHover(graph) {
        // console.log('onHover:', graph);
    }
    onSelect(graph) {
        if (!this.showSelect)
            return;
        if (!graph)
            return;
        this.drawStatus = false;
        const [start, end] = graph.outsideRect || [];
        if (!start || !end)
            return;
        const margin = 8;
        let width = Math.abs(end.x - start.x) + 2 * margin;
        let height = Math.abs(end.y - start.y) + 2 * margin;
        let offestX = start.x - margin;
        let offestY = start.y - margin;
        // 做适配
        if (width < this.minGraphSize.width) {
            const dis = this.minGraphSize.width - width;
            offestX -= dis / 2;
            width = this.minGraphSize.width;
        }
        if (height < this.minGraphSize.height) {
            const dis = this.minGraphSize.height - height;
            offestY -= dis / 2;
            height = this.minGraphSize.height;
        }
        // 浅拷贝防止对原graph的修改
        this.selectGraph = { ...graph, width, height, offestX, offestY };
        this.selectGraphId = graph.id;
    }
    cancelSelect() {
        this.clearSelect();
    }
    clearSelect() {
        // this.drawStatus = false;  处理一次绘制多个bug
        this.selectGraph = undefined;
        this.selectGraphId = '';
    }
    setDirection(graph, atlas) {
        this.directionManager.setDirection(graph);
        if (graph.direction) {
            const directionEnd = graph.direction.iconPosition.map((item) => getEndPoint({ x: item.x, y: item.y }, item.angle - 270));
            graph.direction.end = directionEnd;
        }
        this.regainDirections(atlas);
    }
    regainDirections(atlas) {
        this.atlasWidthDirection = atlas?.filter((graph) => graph.direction);
    }
    handleType(type) {
        this.clearSelect();
        this.type = type;
    }
    handleClear() {
        this.clearSelect();
        this.atlas = [];
        this.atlasWidthDirection = [];
    }
    handleSave() {
        this.clearSelect();
        const paint = this.$refs.paint;
        const atlas = paint.drawerBatch.getAtlas();
        const noChoose = atlas.some((graph) => graph?.direction?.choose === -1);
        if (noChoose) {
            this.$emit('noSelectDirection', this.abs(atlas));
            return void this.$message.warning(this.$t('selectDirection').toString());
        }
        paint.save();
        this.$emit('drawend', this.abs(this.atlas));
    }
    handleClose() {
        this.clearSelect();
        const paint = this.$refs.paint;
        paint.close();
        this.regainDirections(this.atlas);
        this.$emit('drawend', this.abs(this.atlas));
    }
    relative(atlas) {
        const paint = this.$refs.paint;
        return paint.convert(atlas, false);
    }
    abs(atlas) {
        const paint = this.$refs.paint;
        return paint.convert(atlas);
    }
    handleUndo() {
        const paint = this.$refs.paint;
        paint.undo();
    }
    handleRedo() {
        const paint = this.$refs.paint;
        if (!this.check(paint.drawerBatch.getAtlas(), false))
            return;
        paint.redo();
    }
    handleDeleteGraph() {
        this.deleteGraph(this.selectGraphId);
    }
    deleteGraph(graphId) {
        MapPolygonsModule.removeCrowdMapPolygons(graphId);
        MapPolygonsModule.removeSubmitPolyonsData(graphId);
        const paint = this.$refs.paint;
        paint.deleteGraph(graphId);
        this.handleSave();
    }
    handleChooseDirection(graph, direction) {
        this.directionManager.setChoose(graph, direction);
        const paint = this.$refs.paint;
        paint.save();
        this.$emit('drawend', this.abs(this.atlas));
    }
    setDirectionManager() {
        this.directionManager = new DirectionManager(this.typeWithDirection, { width: 30, height: 90 });
    }
    check(atlas, isEnd = true) {
        if (!this.limits)
            return true;
        const count = this.limits[this.type];
        const total = this.limits.total;
        if (count !== undefined) {
            const typedAtlas = atlas.filter((graph) => graph.type === this.type);
            if (typedAtlas.length >= (isEnd ? count + 1 : count))
                return false;
        }
        if (total !== undefined && atlas.length >= (isEnd ? total + 1 : total))
            return false;
        return true;
    }
    resize() {
        const clientRadio = 1.775;
        const { width } = this.style;
        const maxH = document.documentElement.clientHeight - 250;
        const maxW = document.documentElement.clientWidth - 200;
        const height_ = Math.min(maxH, width);
        const width_ = Math.min(maxW, width);
        if (height_ * clientRadio > width_) {
            this.style.width = width_;
            this.style.height = width_ / clientRadio;
        }
        else {
            this.style.width = height_ * clientRadio;
            this.style.height = height_;
        }
    }
    setTypeDirection() {
        this.typeWithDirection = this.directionConfig;
        if (!this.typeWithDirection || Object.keys(this.typeWithDirection).length < 1) {
            this.typeWithDirection = { line: 1, lines: (length) => Math.floor((length - 1) / 2) + 1 };
        }
    }
    setDefaultType(buttons) {
        this.type = buttons[0] || 'unknown';
    }
    created() {
        this.resize();
    }
    onPaintMounted() {
        this.atlas = this.relative(this.dataSource) || [];
        this.setDefaultType(this.buttons);
        this.regainDirections(this.atlas);
    }
    mounted() {
        this.initDirection();
    }
    initDirection() {
        this.setTypeDirection();
        this.setDirectionManager();
        this.regainDirections(this.atlas);
    }
    onChangeindexActive(val) {
        this.initCirclePosition(this.polygonPoints);
    }
    graphAffirmChange(vertices) {
        MapPolygonsModule.updateCurrPolygonPoints(vertices.length);
    }
    onChangePointsLen(val) {
        this.initCirclePosition(val);
    }
    initCirclePosition(val) {
        if (!this.showPoints)
            return;
        if (val >= 0 && this.indexActive >= 0) {
            // 未开始绘制或未选择roi区域不进行位置计算
            let vertices = this.atlas[this.indexActive].vertices;
            this.verticePosition = { ...vertices[val] };
        }
    }
};
__decorate([
    Prop({ type: Object })
], VideoDrawer.prototype, "styleProp", void 0);
__decorate([
    Prop({ default: true })
], VideoDrawer.prototype, "showSelect", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "showPoints", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "indexActive", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "polygonPoints", void 0);
__decorate([
    Watch('dataSource')
], VideoDrawer.prototype, "onChangeDataSource", null);
__decorate([
    Watch('paintState')
], VideoDrawer.prototype, "onchangePaintState", null);
__decorate([
    Watch('roiType')
], VideoDrawer.prototype, "onchangeRoiType", null);
__decorate([
    Watch('styleProp', { immediate: false, deep: true })
], VideoDrawer.prototype, "onSpecifiedStyleChange", null);
__decorate([
    Watch('indexActive')
], VideoDrawer.prototype, "onChangeindexActive", null);
__decorate([
    Watch('polygonPoints')
], VideoDrawer.prototype, "onChangePointsLen", null);
VideoDrawer = __decorate([
    Component({
        name: 'VideoDrawer',
        components: {
            Paint,
        },
        props: {
            dataSource: Array,
            buttons: Array,
            limits: Object,
            roiType: String,
            directionConfig: Object,
            options: Object,
            specifiedStyle: Object || undefined,
            isShow: Boolean,
            paintState: Boolean,
        },
        watch: {
            buttons(value) {
                this.onButtonsChange(value);
            },
            directionConfig(value) {
                this.typeWithDirection = value;
                this.initDirection();
            },
        },
        i18n: {
            messages: {
                'en-us': {
                    exceedLimit: 'draw to many items',
                    selectDirection: 'please select the direction',
                    concaveError: 'No concave polygons',
                },
                zh: {
                    exceedLimit: '绘制的图形数量超出限制',
                    selectDirection: '请选择正方向',
                    concaveError: '不支持凹多边形',
                },
            },
        },
    })
], VideoDrawer);
export default VideoDrawer;
